import Axios from "../helpers/axios";

export const getAllTopics = () => {
  return Axios.get("/topics");
};

export const getDetailTopic = (topic_id) => {
  return Axios.get(`/topics/${topic_id}`);
};
